export default __webpack_public_path__ + "static/AeonikBlack-7b70c0f8aaea690e0b71b2751ce0d3d0.woff2";